export default __webpack_public_path__ + "static/media/rubic.61627ed6.svg";